/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeRequired, makeValidate } from "mui-rff";
import { schema } from "@/features/user/seriesFolios/validations";
import { makeYupTranslatedError } from "@/helpers/yup";
import { Box, MenuItem } from "@mui/material";
import { toastError, toastSuccess } from "@/helpers/toast";
import Page from "@/components/page";
import SeriesFolioForm from "@/features/user/seriesFolios/components/form";
import { getAllSeries, saveSerie } from "@/apis/series";
import lGet from "lodash/get";
import { convertJSONToString, errorMessageFromServer } from "@/utils/server";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBackdrop } from "@/store/slices/appSlice";
import { checkErrorResponse } from "@/helpers/axios";

const initialData: any = {
    serie: 'A',
    folio: '1'
}

const SeriesFolioComponent = ({ isModal, closePopover, stepperCallback, from = "Route" }: any): any => {
    //console.log("@SeriesFolioComponent loading component from ", from);

    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    // list of all series and folios
    const [seriesData, setSeriesData] = useState([]);

    //const data: any = initialData;
    const dataRef = useRef(initialData);

    const validateForm = makeValidate(schema, makeYupTranslatedError);

    const required = makeRequired(schema);

    /*
    *
    * FORMS
    *
    * */

    const onSubmit = async (values: any, form: any) => {
        submitData(values, form).catch((e) => console.error(e));

        //await setSubmitting(true);
    }

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const submitData = useCallback(async (payload: any, form: any) => {
        await setSubmitting(true);

        try {
            // fixing lowercase
            const payload_transform: any = {
                ...payload,
                serie: payload.serie.toUpperCase()
            }

            await saveSerie(payload_transform);

            const isCreateInvoice: boolean = location.pathname.includes('/create/invoice')

            // reset and restart form validations
            form.reset();
            form.restart();

            // get all series again
            const responseSeries = await getAllSeries();
            setSeriesData(responseSeries.data.series);

            toastSuccess(t('series.save_text'), {
                onOpen: () => (isModal && isCreateInvoice) && dispatch(setBackdrop(true)),
                onClose: () => (isModal && isCreateInvoice) && history.go(0)
            });

            // sense changes in complete register
            if (!isModal && stepperCallback) {
                stepperCallback();
            }

            if (isCreateInvoice)
                return true;
            else
                return false; // not closing modal
        } catch (error) {
            if (lGet(error, 'data')) {
                const errors = error.data.errors;
                const message = errorMessageFromServer(convertJSONToString(errors));
                toastError(message);
            } else {
                console.error('error: ', error);
                checkErrorResponse(error);
            }

            // not closing modal
            return false;
        } finally {
            // stop
            await setSubmitting(false);
        }
    }, []);

    const formProps: any = {
        onSubmit,
        initialValues: dataRef.current,
        validateForm,
        required,
        submitting,
        isModal,
        closePopover,
        series: seriesData,
        setModalOpen,
        loading
    }

    const getData = useCallback(async () => {
        // set loader
        setLoading(true);

        // get list of series & folios
        const response = await getAllSeries();
        setSeriesData(response.data.series);

        setLoading(false);
    }, []);

    useEffect(() => {
        //console.log('@mounting series & folio component');
        if (!isModal)
            getData().catch((e) => console.error(e));
    }, []);

    useEffect(() => {
        //console.log("@SeriesFolioComponent sensing value modalOpen: ", modalOpen);
        if (modalOpen) {
            //console.log("@SeriesFolioComponent modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])
    //console.log('isModal', isModal);

    return (
        <Box
            sx={{
                ...(!isModal && {
                    m: 2,
                }),
            }}
        >
            {/*{(loading && !isModal) && <>{t('common.loading')}</>}

            {(loading && isModal) && <MenuItem>{t('series.modal_title')}</MenuItem>}*/}

            {<SeriesFolioForm {...formProps} />}
        </Box>
    );
}

export default SeriesFolioComponent;
